import PhoneVerificationForm from '../../../../../components/PhoneVerificationForm';

const PhoneVerification = ({ onVerified, onBack }) => {
  return (
    <PhoneVerificationForm
      onVerified={onVerified}
      onBack={onBack}
    />
  );
};

export default PhoneVerification;
